<template>
  <div>
    <tk-flex between >
      <public-header title="买赠申请" show-back></public-header>
      <a-button v-if="pageData && pageData.objectId && pageData.status === '0' && isAgent" type="primary" @click="cancel(0)" >
        取消申请
      </a-button>
      <a-button v-if="pageData && pageData.objectId && pageData.status === '1' && isAgent && isCancel" type="primary" @click="cancel(1)" >
        取消买赠
      </a-button>
      <a-button v-if="pageData && pageData.objectId && pageData.status === '0' && !isAgent && can('reviewGiftApplyModel')" type="primary" @click="audit()" >
        审核
      </a-button>
    </tk-flex>
    <a-spin :spinning="loading">
      <div class="full-width bg-white border-radius-12 p-24" style="color: #363B45" >
        <tk-flex middle :gutter="8"  wrap>
          <div class="p-r-8 font-bold font-20" v-if="pageData && pageData.objectId">代理商：{{ pageData.agent.nickName }}</div>
          <div class="p-x-8 p-y-4" :style="{'border-radius': '6px','border': '1px solid' + status(pageData.status, 'color'),'color': status(pageData.status, 'color')}" >{{ status(pageData.status, 'string') }}</div>
        </tk-flex>
        <!-- 基本信息 -->
        <div>
          <div class="font-14 font-bold m-t-24 m-b-20" >基本信息</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" v-if="pageData && pageData.objectId" >
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="!isAgent" >
              战区：{{ pageData.warZone.name }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="!isAgent"  >
              大区：{{ pageData.regional.name }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="!isAgent" >
              所属地区：{{ pageData.agent.nickName }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              <tk-flex>
                买赠主图：
                <viewer v-if="pageData.mainImage" :images="[pageData.mainImage]">
                  <img :src="pageData.mainImage" style="width: 120px;height: 120px;border: 1px solid #E1E4EB;border-radius: 7px;" />
                </viewer>
                <span v-else>-</span>
              </tk-flex>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              截止日期：{{ pageData.deadline | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              创建时间：{{ pageData.createdAt | date }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>

        <!-- 商品详情 -->
        <div style="width: 100%;overflow: hidden;">
          <div class="font-14 font-bold m-t-24 m-b-20" >商品信息</div>
          <a-table
            v-if="device !== 'mobile'"
            style="width: 100%"
            :columns="columns" :data-source="data" :pagination="false" :scroll="{x: 600}" size="small">
            <div slot="image" slot-scope="text">
              <viewer v-if="text" :images="text">
                <img v-for="(t,i) in text" :key="i" :src="t" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" :style="{'display': i===0?'':'none'}" />
              </viewer>
              <span v-else> 暂无 </span>
            </div>
          </a-table>
          <div v-else>
            <a-descriptions bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
              <a-descriptions-item
                v-for="( itm, i) in columns" :key="`item${i}`"
                :label="itm.title"
              >
                <div v-if="itm.dataIndex === 'image'">
                  <viewer v-if="item[itm.dataIndex]" :images="[item[itm.dataIndex]]">
                    <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                  </viewer>
                  <span v-else> 暂无 </span>
                </div>
                <div v-else>{{ item[itm.dataIndex] }}</div>
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>

        <!-- 赠品详情 -->
        <div style="width: 100%;overflow: hidden;">
          <div class="font-14 font-bold m-t-24 m-b-20" >赠品信息</div>
          <a-table
            v-if="device !== 'mobile'"
            style="width: 100%" :columns="columnsGift" :data-source="dataGift" :pagination="false" :scroll="{x: 600}" size="small">
            <div slot="image" slot-scope="text">
              <viewer v-if="text" :images="text">
                <img v-for="(t,i) in text" :key="i" :src="t" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" :style="{'display': i===0?'':'none'}" />
              </viewer>
              <span v-else> 暂无 </span>
            </div>
          </a-table>
          <div v-else>
            <a-descriptions bordered v-for="(item,index) in dataGift" :key="index" style="margin-bottom: 20px">
              <a-descriptions-item
                v-for="( itm, i) in columnsGift" :key="`item${i}`"
                :label="itm.title"
              >
                <div v-if="itm.dataIndex === 'image'">
                  <viewer v-if="item[itm.dataIndex]" :images="[item[itm.dataIndex]]">
                    <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                  </viewer>
                  <span v-else> 暂无 </span>
                </div>
                <div v-else>{{ item[itm.dataIndex] }}</div>
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>

        <!-- 审核信息 -->
        <div v-if="pageData.status === '1' || pageData.status === '2'">
          <div class="font-14 font-bold m-t-24 m-b-20" >审核信息</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" >
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              审核结果：{{ pageData.status === '1' ? '通过' : '未通过' }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              审核意见：{{ pageData.opinion || '-' }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              审核时间：{{ pageData.auditTime | date }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
      </div>
    </a-spin>

    <!-- 回复弹框 -->
    <!-- 弹框 -->
    <Audit v-if="visible" :record="pageData" @complete="close" ></Audit>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'
import Audit from '../../core/component/gift/audit.vue'
export default {
  components: {
    publicHeader,
    Audit
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      columns: [
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '系列',
          dataIndex: 'series',
          key: 'series',
          width: 100
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          key: 'name',
          width: 150
        },
        {
          title: '电压',
          dataIndex: 'voltage',
          key: 'voltage',
          width: 80
        },
        {
          title: '容量',
          dataIndex: 'capacity',
          key: 'capacity',
          width: 100
        }
      ],
      data: [
        {
          image: '',
          series: '',
          name: '',
          voltage: '',
          capacity: ''
        }
      ],
      columnsGift: [
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          key: 'name',
          width: 150
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '成本价',
          dataIndex: 'costPrice',
          key: 'costPrice',
          width: 100
        },
        {
          title: '价格',
          dataIndex: 'price',
          key: 'price',
          width: 100
        }
      ],
      dataGift: [
        {
          image: '',
          name: '',
          number: '1',
          costPrice: '',
          price: ''
        }
      ],
      visible: false, // 弹框
      isCancel: false // 是否可以取消
    }
  },
  // 监听页面id的变化
  watch: {
    $route (to, from) {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    status (status, type) {
      let str = ''
      let color = ''
      switch (status) {
        case '0':
          str = '待审核'
          color = '#2F82FF'
          break
        case '1':
          str = '已通过'
          color = '#0ABA50'
          break
        case '2':
          str = '未通过'
          color = '#FF2A58'
          break
        case 'cancel':
          str = '已取消'
          color = '#808690'
          break
        default:
          break
      }
      return type === 'string' ? str : color
    },
    // 初始化菜单按钮
    async init () {
      try {
        const { data } = await this.$tkParse.get(`/classes/giftApply/${this.$route.query.id}`, {
          params: { include: 'commodity,winWinMerchantProduct,gift,commodity.voltage,commodity.capacity,commodity.series,warZone,regional,agent' }
        })
        console.log('申请', data)
        if (data.isBatch) {
          this.data = await this.getData(data.productArr)
        } else {
          this.data[0].image = data.commodity.images
          this.data[0].series = data.commodity.series.name
          this.data[0].name = data.commodity.name
          this.data[0].voltage = data.commodity.voltage.name
          this.data[0].capacity = data.commodity.capacity.name
        }

        this.dataGift[0].image = [data.gift.image]
        this.dataGift[0].name = data.gift.name
        this.dataGift[0].costPrice = data.gift.costPrice
        this.dataGift[0].price = data.gift.price

        console.log(this.data, '结果')
        // 判断当前时间是否 超过deadline 超过则不可取消
        let now = await this.$tkParse.get('https://api.mokekeji.com/time')
        if (new Date(now.data).getTime() > new Date(data.deadline).getTime()) {
          this.isCancel = false
        } else {
          this.isCancel = true
        }

        this.pageData = data
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async getData (arr) {
      const res = await this.$tkParse.get(`/classes/winWinMerchantProduct`, {
        params: {
          include: 'commodity,commodity.series,commodity.voltage,commodity.capacity',
          where: {
            objectId: {
              $in: arr
            }
          }
        }
      })
      if (res.data.results.length === 0) {
        return []
      }
      let data = []
      res.data.results.forEach(item => {
        data.push({
          image: item.commodity.images,
          series: item.commodity.series.name,
          name: item.commodity.name,
          voltage: item.commodity.voltage.name,
          capacity: item.commodity.capacity.name
        })
      })
      return data
    },
    // 审核
    async audit () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.init()
    },
    // 取消
    async cancel (type) {
      try {
        await this.confirm('警告', '确定取消吗？')
        if (type === 0) {
          this.loading = true
          try {
            await this.$tkParse.put(`/classes/giftApply/${this.$route.query.id}`, {
              status: 'cancel'
            })
            this.$notification['success']({
              message: '取消成功',
              description: '取消成功'
            })
            this.loading = false
            this.init()
          } catch (error) {
            console.log(error)
            this.loading = false
            this.$notification['error']({
              message: '取消失败',
              description: '网络错误,请重试'
            })
          }
        }
        if (type === 1) {
          await this.$tkParse.put(`/classes/giftApply/${this.$route.query.id}`, {
            status: 'cancel'
          })
          if (this.pageData.isBatch) {
            console.log('批量')
            console.log(this.pageData.productArr)
            for (let index = 0; index < this.pageData.productArr.length; index++) {
              const element = this.pageData.productArr[index]
              await this.$tkParse.put(`/classes/winWinMerchantProduct/${element}`, {
                gift: null,
                mainImage: null,
                pinkage: null,
                deadline: null
              })
              let wProduct = await this.$tkParse.get(`/classes/winWinMerchantProduct/${element}`)
              console.log('🚀 ~ file: giftApplyDetail.vue:390 ~ cancel ~ wProduct:', wProduct.data)
              await this.$tkParse.post(`/commodity/WWMProductActivity`, {
                commodity: wProduct.data.commodity
              })
            }
          } else {
            console.log('单个')
            console.log(this.pageData.winWinMerchantProduct)
            await this.$tkParse.put(`/classes/winWinMerchantProduct/${this.pageData.winWinMerchantProduct.objectId}`, {
              gift: null,
              mainImage: null,
              pinkage: null,
              deadline: null
            })
            await this.$tkParse.post(`/commodity/WWMProductActivity`, {
              commodity: this.pageData.commodity.objectId
            })
          }
          this.$notification['success']({
            message: '取消成功',
            description: '取消成功'
          })
          this.loading = false
          this.init()
        }
      } catch (error) {
        console.log('🚀 ~ file: giftApplyDetail.vue:385 ~ cancel ~ error:', error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
